/* eslint react/prop-types: 0 */
import React from 'react';
import { formatMoney } from '../../../utils/money';
import { sortByDate, formatDate } from '../../../utils/date';
import ResultLink from '../../../shared/links/ResultLink';
import {
  JockeyLink, TrainerLink, HorseLink,
} from '../../../shared/links/ProfileLink';

const columns = type => [
    {
        key: 'raceDate',
        header: 'date',
        cell: ({ raceDate }) => formatDate(raceDate, 'DDMMMYY'),
        sortFn: sortByDate('raceDate'),
    },
    {
        key: 'raceInstanceTitle',
        header: 'race name',
        cell: rowData => (
            <ResultLink {...rowData}>{ rowData.raceInstanceTitle }</ResultLink>
        ),
    },
    {
        key: 'horseStyleName',
        header: 'horse',
        cell: HorseLink,
    },
    type === 'trainer' ? {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: JockeyLink,
    } : {
        key: 'trainerStyleName',
        header: 'trainer',
        cell: TrainerLink,
    },
    {
        key: 'prizeSterling',
        header: 'winnings',
        cell: ({ prizeSterling }) => formatMoney(prizeSterling),
    },
];

export default columns;



// WEBPACK FOOTER //
// ./src/js/human/stats/bigRaceWins/columns.jsx